import React, { Fragment, useContext, useState } from 'react';
import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Row } from 'reactstrap';
import { H5, Btn } from '../../../../AbstractElements';
import { Draft, More, Spam, Trash } from '../../../../Constant';
import EmailContext from '../../../../_helper/Email';
import { Link } from 'react-router-dom';

const EmailTopToggle = ({ selectedFav, moreCallBack }) => {
    const { type } = useContext(EmailContext);

    const [dropdownOpen, setOpen] = useState(false);
    const toggle = () => setOpen(!dropdownOpen);
    var newBtnText='';
    var applicationLink='';

    if(type==='Programmes'){
      newBtnText='MAKE AN APPLICATION';
      applicationLink=`${process.env.PUBLIC_URL}/dpsm/scheme/ltp`;
    }
    else if(type==='Training'){
      newBtnText='NEW TRAINING APPLICATION';
    }
    else if(type==='Leave'){
      newBtnText='NEW LEAVE APPLICATION';
    }
    else if(type==='Vacancies'){
      newBtnText='NEW VACANCY APPLICATION';
    }
    else if(type==='Benefits & Claims'){
      newBtnText='NEW CLAIM APPLICATION';
    }
    else {
      newBtnText='NEW APPLICATION';
    }

    return (
        <Fragment>
            <div className="email-top">
                <Row>
                    <Col>
                        <H5>{type}</H5>
                    </Col>
                    <Col className="text-end">
					
                     <div >
                      <Row>
                        
                        <Col sm='xl-50' className='btn-middle text-end'>
                        <Link to={applicationLink} >
                          <Btn attrBtn={{ color: 'primary', className: 'btn-mail text-center mb-0 mt-0' }}>
                            <i className='fa fa-paper-plane me-2'></i>
                            {newBtnText}
                          </Btn>
                          </Link>
                        </Col>
                      </Row>
                    </div>
						
                    </Col>
                </Row>
            </div>
        </Fragment>
    )
}

export default EmailTopToggle;